module.exports = __webpack_public_path__ + "static/media/synth_16.93a64ba7.mp3";